export enum DBConnectionType {
	MySQL,
	MSSQL,
	POSTGRESQL,
	SUPABASE,
}
